"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _base2 = _interopRequireDefault(require("./_base"));
var _adr = _interopRequireDefault(require("./adr"));
var _airturn = _interopRequireDefault(require("./airturn"));
var _aodb = _interopRequireDefault(require("./aodb"));
var _chat = _interopRequireDefault(require("./chat"));
var _realtime = _interopRequireDefault(require("./realtime"));
var _task = _interopRequireDefault(require("./task"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import stand from "./stand";

var themes = {
  _base: _base2["default"],
  adr: _adr["default"],
  airturn: _airturn["default"],
  aodb: _aodb["default"],
  task: _task["default"],
  realtime: _realtime["default"],
  chat: _chat["default"]
};
var _default = themes;
exports["default"] = _default;